module.exports = __webpack_public_path__ + "24210dda98c26c40f69d8637bd3c662e.jpg";